import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/nextjs-toploader/dist/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/app/node_modules/react-toastify/dist/react-toastify.esm.mjs");
;
import(/* webpackMode: "eager" */ "/app/src/app/industries/global_industries.scss");
;
import(/* webpackMode: "eager" */ "/app/src/Component/Footer/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/Component/Footer/logoFoter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/Component/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProgressBarShow"] */ "/app/src/Component/ProgressBarHeader/index.tsx");
